import { useMemo } from "react";
import CustomizeControlSearchBar from "./CustomizeControlSearchBar";
import CustomizeControlTopLeftSection from "./CustomizeControlTopLeftSection";
import CustomizeControlTopRIghtSection from "./CustomizeControlTopRIghtSection";
import { useNistCheckboxContext } from "../CustomizeControlsTable";
import { useCustomizeControlsStore } from "@/modules/agent/states/cusomize-controls";

const CustomizeControlTopSection = () => {
  // const { showCheckboxes } = useNistCheckboxContext();
  const {showCheckboxes} = useCustomizeControlsStore();
  const { changesMade } = useCustomizeControlsStore();

  // Force component to re-evaluate on changes
  const key = useMemo(() => `top-section-${changesMade}`, [changesMade]);

  return (
    <div key={key} className="px-6 py-4 grid grid-cols-3 min-h-[69px] bg-white gap-2">
      <div className="col-span-1 items-center my-auto">
        <CustomizeControlTopLeftSection />
      </div>

      <div className="col-span-1">
      {/* Conditionally render search bar based on showCheckboxes */}
      {!showCheckboxes && (
          <CustomizeControlSearchBar />
        
      )}
      </div>
      <div className="col-span-1 flex justify-end items-center my-auto">
        <div className="flex flex-row gap-1">
          <CustomizeControlTopRIghtSection />
        </div>
      </div>
    </div>
  );
};

// Remove memo since it's causing rendering issues
export default CustomizeControlTopSection;
